import { useRef } from 'react';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';
import { RenewalsSelector } from 'components/RenewalsSelector/RenewalsSelector';

export const RenewalBulkConfigurationModal = ({
  visible,
  renewalConfigs,
  companyChecks,
  onSubmit = () => {},
  onClose = () => {},
}) => {
  const renewalsSelectorRef = useRef(null);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title="Add Renewal Check"
      description="Select the checks you'd like to renew for the selected employees. If a check has been run before, the next renewal date will be calculated from the last completed check, not the date set below."
      small>
      <RenewalsSelector
        ref={renewalsSelectorRef}
        renewalConfigs={renewalConfigs}
        companyChecks={companyChecks}
        onSubmit={onSubmit}
      />
      <div className="d-flex justify-content-end">
        <Button onClick={() => renewalsSelectorRef.current.submit()}>Add renewals</Button>
      </div>
    </AnimatedModal>
  );
};
